var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-task-progress"},[(_vm.count == 0)?_c('div'):_c('div',{class:{'text-success text-bold': _vm.done == _vm.count}},[_vm._v(_vm._s(_vm.done)+"/"+_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }